import { render, staticRenderFns } from "./WizardCancelContract.vue?vue&type=template&id=7cd61460&"
import script from "./WizardCancelContract.vue?vue&type=script&lang=js&"
export * from "./WizardCancelContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports